import { render, staticRenderFns } from "./registroPadre.vue?vue&type=template&id=06b6295a&scoped=true"
import script from "./registroPadre.vue?vue&type=script&lang=js"
export * from "./registroPadre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6295a",
  null
  
)

export default component.exports